import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import App from './App'; // We will use Report component directly
import Report from './Report'; // Import the Report component
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <App /> */}
    <Report /> {/* Render the Report component */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
